import { GridItem, GridItemProps } from "@chakra-ui/react"

function DescriptionDefinition({ children, ...rest }: { children: React.ReactNode } & GridItemProps) {
  return (
    <GridItem as="dd" {...rest}>
      {children}
    </GridItem>
  )
}

export default DescriptionDefinition
